<template >
  <v-app>
    <div>
      <!-- <div style="margin-bottom:10px;">
        <v-layout wrap>
          <v-flex xs8>
            <h3 style="margin:0px;">Order List</h3>
          </v-flex>
          <v-flex xs4>
            <button
              style="float:right;width:100px;height:30px;background-color:#1976d2;color:white;font-size:14px;border-radius:5px;"
              @click="toAddOrder()"
            >Add order</button>
          </v-flex>
        </v-layout>
      </div>-->

      <div v-if="errorList != ''" style="text-align: center;margin:10px;">
        <h3 style="font-size:14px;" class="txtClrRed">{{$t('ErrorList')}}: {{errorList}}</h3>
      </div>

      <!-- order list -->
      <v-layout v-if="ListOfTrnHdr.length>0" wrap style="margin-top:10px;">
        <v-card
          v-for="orderHdr in ListOfTrnHdr"
          :key="orderHdr.id"
          style="width:100%;height:auto;margin-bottom:8px;background-color:#F4B95F;"
        >
          <v-layout wrap>
            <v-flex xs7>
              <p
                style="margin:8px;margin-bottom:0px;text-align:left;font-size:14px !important;"
              >{{ orderHdr.oa }}</p>
              <p
                style="margin:8px;margin-bottom:0px;margin-top:0px;text-align:left;font-size:14px !important;"
              >{{ orderHdr.schdTypeName }}</p>
              <p
                style="margin:8px;margin-top:0px !important;margin-bottom:0px;text-align:left;font-size:14px !important;"
              >{{ orderHdr.mx }}</p>
              <p
                style="margin:8px;margin-top:0px !important;text-align:left;font-size:14px !important;"
              >{{ orderHdr.dy }}</p>
            </v-flex>
            <v-flex xs5>
              <div style="margin:8px;">
                <p
                  v-if="orderHdr.lz !=''"
                  style="margin:0px;font-size:25px !important;text-align: right;"
                >{{ orderHdr.lz }}</p>
                <p
                  v-if="orderHdr.ez !=''"
                  style="margin:0px;font-size:14px !important;text-align: right;overflow-wrap: break-word;"
                >{{ orderHdr.ez }}</p>
                <p
                  v-if="orderHdr.y !=''"
                  style="margin:0px;font-size:14px !important;text-align: right;overflow-wrap: break-word;"
                >{{ orderHdr.y }}</p>
                <p
                  v-if="orderHdr.ly !=''"
                  style="margin:0px;font-size:14px !important;text-align: right;overflow-wrap: break-word;"
                >{{ orderHdr.ly }}</p>
                <p
                  v-if="orderHdr.en !='' && (orderHdr.mw == 3)"
                  style="margin:0px;font-size:12px !important;text-align: right;overflow-wrap: break-word;"
                >{{ orderHdr.en }}</p>
                <p
                  v-if="orderHdr.y !='' && (realKtnID == 0) && (WAReplyMsg !='')"
                  style="color:blue;text-decoration: underline;margin:0px;font-size:12px !important;text-align: right;overflow-wrap: break-word;"
                  @click="openWA(orderHdr.WALink)"
                >
                  <a>{{$t('WhatsAppReply')}}</a>
                </p>
              </div>
            </v-flex>
          </v-layout>
          <!-- order Dtl -->
          <v-layout wrap xs12 style="padding:0px 5px 0px 5px;">
            <v-card style="width:100%;height:auto;background-color:whitesmoke;">
              <v-layout
                v-for="orderDtl in orderHdr.ListOfTrnDtl"
                :key="orderDtl.id"
                wrap
                style="border-bottom:0.5px solid gainsboro;"
              >
                <v-flex xs7>
                  <p
                    v-if="orderDtl.ln != ''"
                    class="orderDtlMediumTxt"
                  >{{ orderDtl.ll }} - {{ orderDtl.ln }}</p>
                  <p v-if="orderDtl.ln == ''" class="orderDtlMediumTxt">{{ orderDtl.ll }}</p>
                  <p class="orderDtlMediumTxt">{{ orderDtl.lm }}</p>
                  <!-- <p class="orderDtlMediumTxt">{{ orderDtl.ln }}</p> -->
                </v-flex>
                <v-flex xs2>
                  <p style="margin:10px;text-align: center;">{{ orderDtl.lo }}</p>
                </v-flex>
                <v-flex xs2>
                  <p class="orderDtlSmallTxt">{{ orderDtl.rowAmt }}</p>
                </v-flex>
                <v-flex xs1>
                  <v-icon
                    style="color:black;"
                    class="dltRowBtn"
                    @click="orderEndOrDlt('delete',orderDtl.lk)"
                  >delete</v-icon>
                </v-flex>
              </v-layout>
            </v-card>
          </v-layout>
          <v-layout
            v-if="orderHdr.rs>0 && realKtnID == 0"
            wrap
            xs12
            style="padding:5px;padding-top:0px;padding-bottom:0px;"
          >
            <v-card style="width:100%;height:auto;background-color:#dddddd;">
              <v-layout wrap style="border-bottom:0.5px solid gainsboro;">
                <!-- order bottom -->
                <v-flex xs7>
                  <p style="margin:10px;text-align: right;">{{$t('DeliveryCharges')}}</p>
                </v-flex>
                <v-flex xs2></v-flex>
                <v-flex xs2>
                  <p class="orderDtlSmallTxt">{{ orderHdr.rs.toFixed(2) }}</p>
                </v-flex>
                <v-flex xs1></v-flex>
              </v-layout>
            </v-card>
          </v-layout>
          <v-layout wrap xs12 style="padding:5px;padding-top:0px;padding-bottom:0px;">
            <v-card style="width:100%;height:auto;background-color:#dddddd;">
              <v-layout wrap style="border-bottom:0.5px solid gainsboro;">
                <!-- order bottom -->
                <v-flex xs7>
                  <!-- <v-btn
                    color="success"
                    style="height:30px;"
                    @click="orderEndOrDlt('end',orderHdr)"
                  >{{$t('Finish')}}</v-btn>-->
                  <p style="margin:10px;text-align: right;">{{$t('Total')}}</p>
                </v-flex>
                <v-flex xs2>
                  <p style="margin:10px;text-align: center;">{{ orderHdr.tolQtyPerOrder }}</p>
                </v-flex>
                <v-flex xs2>
                  <p v-if="realKtnID != 0" class="orderDtlSmallTxt">{{ orderHdr.tolAmtPerOrder }}</p>
                  <p
                    v-if="realKtnID == 0"
                    class="orderDtlSmallTxt"
                  >{{ orderHdr.tolAmtPerOrderWDlvChg }}</p>
                </v-flex>
                <v-flex xs1>
                  <v-icon
                    style="color:black;"
                    class="dltRowBtn"
                    @click="orderEndOrDlt('deleteAll',orderHdr.ListOfTrnDtl)"
                  >delete</v-icon>
                </v-flex>
              </v-layout>
            </v-card>
          </v-layout>
          <v-layout wrap xs12 style="padding:5px;padding-top:0px;">
            <v-card style="width:100%;height:auto;background-color:#c6c6c6;">
              <v-layout wrap style="border-bottom:0.5px solid gainsboro;">
                <!-- order bottom -->
                <v-flex xs7>
                  <v-btn
                    color="success"
                    style="height:30px;"
                    @click="orderEndOrDlt('end',orderHdr)"
                  >{{$t('Finish')}}</v-btn>
                </v-flex>
                <v-flex xs2>
                  <p style="margin:0px;margin-top:10px;text-align:center;">{{$t('PaidAmt')}}</p>
                </v-flex>
                <v-flex xs2>
                  <p
                    v-if="orderHdr.lh>0 && realKtnID == 0"
                    class="orderDtlSmallTxt"
                  >{{ orderHdr.tolAmtPerOrderWDlvChg }}</p>
                  <p
                    v-if="orderHdr.lh>0 && realKtnID != 0"
                    class="orderDtlSmallTxt"
                  >{{ orderHdr.tolAmtPerOrder }}</p>
                  <p v-if="orderHdr.lh==0" class="orderDtlSmallTxt">0.00</p>
                </v-flex>
                <v-flex xs1></v-flex>
              </v-layout>
            </v-card>
          </v-layout>
        </v-card>
      </v-layout>
      <v-layout v-if="ListOfTrnHdr.length==0" wrap style="margin-top:10px;">
        <v-container style="padding:0px;">
          <h2 style="margin:30px">{{$t('NoOrderItem')}}</h2>
        </v-container>
      </v-layout>
    </div>

    <v-layout class="text-xs-center">
      <v-dialog v-model="dltOrdDtlDialog" persistent width="400">
        <v-card>
          <v-card-title
            class="headline primary lighten-2"
            primary-title
            style="color: white;"
          >{{$t('Inform')}}</v-card-title>
          <v-card-text>
            <h3>{{$t('sureToDeleteThisOrderItemTxt')}}</h3>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="default" flat @click="sureDltOrdRow()">{{$t('Yes')}}</v-btn>
            <v-btn color="primary" flat @click="dltOrdDtlDialog = false">{{$t('No')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout class="text-xs-center">
      <v-dialog v-model="dltAllOrdDtlDialog" persistent width="400">
        <v-card>
          <v-card-title
            class="headline primary lighten-2"
            primary-title
            style="color: white;"
          >{{$t('Inform')}}</v-card-title>
          <v-card-text>
            <h3>{{$t('sureToDeleteEntireOrderTxt')}}</h3>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="default" flat @click="sureDltAllOrd()">{{$t('Yes')}}</v-btn>
            <v-btn color="primary" flat @click="dltAllOrdDtlDialog = false">{{$t('No')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout class="text-xs-center">
      <v-dialog v-model="loadingDialog" persistent width="1000">
        <v-card height="200">
          <v-card-text>
            <br />
            <!-- <v-btn color="primary" style="float:right;" @click="closeLoadingDialog()">X</v-btn> -->
            <v-layout row wrap align-center>
              <v-progress-circular
                :size="100"
                :width="8"
                color="primary"
                indeterminate
                class="progress-circular"
              ></v-progress-circular>
            </v-layout>
            <div>
              <h3 class="loadingMsg">In progress, please wait a moment.</h3>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>

    <VersionDialog v-if="versionError"></VersionDialog>
  </v-app>
</template>

<script>
import JS from './JsonService'
import VersionDialog from '../src/VersionNotMatchDialog'
// import { Howl, Howler } from 'howler'
var timeOut
var audio = new Audio(require('../public/recv_msg.mp3'))
export default {
  components: {
    VersionDialog
  },
  data() {
    return {
      errorList: '',
      ListOfTrnHdr: [],
      ListOfTrnDtl: [],
      dltOrdDtlDialog: false,
      dltAllOrdDtlDialog: false,
      dltOrdDltId: '',
      dltOrdDltList: [],
      loadingDialog: false,
      versionError: false,
      realKtnID: 0,
      WAReplyMsg: ''
    }
  },
  created: function() {
    // sessionStorage.setItem('backEndAddOrd', false)
    let userInfo = JSON.parse(sessionStorage.getItem('backendLoginInfo'))
    this.realKtnID = userInfo.KtnID
    let rpyMsg = sessionStorage.getItem('WAReplyMsg')
    this.WAReplyMsg = rpyMsg
    this.getOrderList()
    clearTimeout(timeOut)
    this.autoRefresh()
  },
  destroyed() {
    clearTimeout(timeOut)
    console.log('destroy')
  },
  methods: {
    autoRefresh() {
      var $this = this
      timeOut = setTimeout(function() {
        $this.getOrderList()
        clearTimeout(timeOut)
        $this.autoRefresh()
      }, 1000)
    },
    getOrderList() {
      this.versionError = false
      let mchCode = sessionStorage.getItem('backendMchCode')
      //console.log(mchCode)
      let userInfo = JSON.parse(sessionStorage.getItem('backendLoginInfo'))
      //console.log(userInfo)
      //console.log(userInfo.KtnID)
      var version = sessionStorage.getItem('version')
      const url = 'Back/GetOrderList'
      const parameter = {
        av: version,
        kp: mchCode,
        rd: userInfo.KtnID,
        gm: 0
      }
      //console.log(parameter)
      JS.request(url, parameter)
        .then(response => {
          //console.log(response.data)
          if (
            response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
            response.data == 'Version Not Match'
          ) {
            this.versionError = true
          } else {
            this.versionError = false
            if (response.data.ListOfTrnHdr) {
              this.errorList = ''

              //sound
              console.log(this.ListOfTrnHdr)
              console.log(response.data)
              console.log(response.data.ListOfTrnHdr)

              if (response.data.ListOfTrnHdr.length > 0) {
                if (this.ListOfTrnHdr.length > 0) {
                  if (
                    this.ListOfTrnHdr[this.ListOfTrnHdr.length - 1].lf ==
                    response.data.ListOfTrnHdr[
                      response.data.ListOfTrnHdr.length - 1
                    ].lf
                  ) {
                    //console.log('old')
                    audio.pause()
                  } else {
                    //console.log('new')
                    audio.play()
                  }
                } else {
                  //console.log('old')
                  audio.pause()
                }
              }

              this.ListOfTrnHdr = response.data.ListOfTrnHdr
              for (let i = 0; i < this.ListOfTrnHdr.length; i++) {
                this.ListOfTrnHdr[i].lh = this.ListOfTrnHdr[i].lh.toFixed(2)
                this.ListOfTrnHdr[i].mx =
                  new Date(this.ListOfTrnHdr[i].mx)
                    .toString()
                    .substring(8, 10) +
                  ' ' +
                  new Date(this.ListOfTrnHdr[i].mx).toString().substring(4, 7) +
                  ' ' +
                  new Date(this.ListOfTrnHdr[i].mx)
                    .toString()
                    .substring(11, 15) +
                  ' ' +
                  new Date(this.ListOfTrnHdr[i].mx).toLocaleTimeString()
                this.ListOfTrnHdr[i].ListOfTrnDtl = []

                let btnName = JSON.parse(
                  sessionStorage.getItem('SchdTypeBtnName')
                )
                if (this.ListOfTrnHdr[i].mw == 1) {
                  if (btnName.DineIn == '') {
                    this.ListOfTrnHdr[i].schdTypeName = 'Dine In, Pre-order'
                  } else {
                    this.ListOfTrnHdr[i].schdTypeName = btnName.DineIn
                  }
                } else if (this.ListOfTrnHdr[i].mw == 2) {
                  if (btnName.TakeAway == '') {
                    this.ListOfTrnHdr[i].schdTypeName = 'Take Away'
                  } else {
                    this.ListOfTrnHdr[i].schdTypeName = btnName.TakeAway
                  }
                } else if (this.ListOfTrnHdr[i].mw == 3) {
                  if (btnName.Delivery == '') {
                    this.ListOfTrnHdr[i].schdTypeName = 'Delivery'
                  } else {
                    this.ListOfTrnHdr[i].schdTypeName = btnName.Delivery
                  }
                } else if (this.ListOfTrnHdr[i].mw == 4) {
                  if (btnName.ScanOrder == '') {
                    this.ListOfTrnHdr[i].schdTypeName = 'Dine In, Scan, Order'
                  } else {
                    this.ListOfTrnHdr[i].schdTypeName = btnName.ScanOrder
                  }
                }

                let cusPh = this.ListOfTrnHdr[i].y
                if (cusPh.startsWith('0')) {
                  cusPh = '6' + cusPh
                }
                this.ListOfTrnHdr[i].WALink =
                  'https://wa.me/' + cusPh + '?text=' + this.WAReplyMsg
              }
              this.getListListOfTrnDtlPerItem(response.data.ListOfTrnDtl)
            } else {
              this.errorList = response.data
            }
          }
        })
        .catch(error => {
          //console.log(error)
          this.versionError = false
          this.errorList = error
        })
    },
    getListListOfTrnDtlPerItem(data) {
      for (let i = 0; i < this.ListOfTrnHdr.length; i++) {
        for (let j = 0; j < data.length; j++) {
          if (this.ListOfTrnHdr[i].lf == data[j].lf) {
            this.ListOfTrnHdr[i].tolAmtPerOrder = 0
            this.ListOfTrnHdr[i].tolAmtPerOrderWDlvChg = 0
            this.ListOfTrnHdr[i].tolQtyPerOrder = 0
            this.ListOfTrnHdr[i].ListOfTrnDtl.push(data[j])
            //console.log(this.ListOfTrnHdr[i].ListOfTrnDtl)

            for (let k = 0; k < this.ListOfTrnHdr[i].ListOfTrnDtl.length; k++) {
              this.ListOfTrnHdr[i].ListOfTrnDtl[k].rowAmt =
                this.ListOfTrnHdr[i].ListOfTrnDtl[k].lt +
                this.ListOfTrnHdr[i].ListOfTrnDtl[k].og +
                this.ListOfTrnHdr[i].ListOfTrnDtl[k].oh

              this.ListOfTrnHdr[i].ListOfTrnDtl[k].rowAmt = Number(
                this.ListOfTrnHdr[i].ListOfTrnDtl[k].rowAmt
              ).toFixed(2)

              var totalPerOder =
                Number(this.ListOfTrnHdr[i].tolAmtPerOrder) +
                Number(this.ListOfTrnHdr[i].ListOfTrnDtl[k].rowAmt)

              this.ListOfTrnHdr[i].tolAmtPerOrder = Number(
                totalPerOder
              ).toFixed(2)

              this.ListOfTrnHdr[i].tolQtyPerOrder =
                this.ListOfTrnHdr[i].tolQtyPerOrder +
                this.ListOfTrnHdr[i].ListOfTrnDtl[k].lo

              this.ListOfTrnHdr[i].tolAmtPerOrderWDlvChg = (
                Number(this.ListOfTrnHdr[i].tolAmtPerOrder) +
                Number(this.ListOfTrnHdr[i].rs)
              ).toFixed(2)

              //console.log(this.ListOfTrnHdr[i].tolAmtPerOrderWDlvChg)
              // this.ListOfTrnHdr[i].tolAmtPerOrder.toFixed(2)
              //console.log(this.ListOfTrnHdr[i].tolAmtPerOrder)
            }
          }
        }
        //console.log(this.ListOfTrnHdr)
      }
    },
    openWA(url) {
      window.open(url)
    },
    orderEndOrDlt(state, val) {
      console.log(state)
      console.log(val)
      if (state == 'delete') {
        this.dltOrdDltId = 0
        this.dltOrdDltId = val
        this.dltOrdDtlDialog = true
      } else if (state == 'deleteAll') {
        this.dltOrdDltList = []
        //this.dltOrdDltIdList = val
        for (let i = 0; i < val.length; i++) {
          this.dltOrdDltList.push(val[i].lk)
        }
        this.dltOrdDltList = this.dltOrdDltList.toString()
        console.log(this.dltOrdDltList)
        this.dltAllOrdDtlDialog = true
      } else if (state == 'end') {
        this.dltOrdDltList = []
        console.log(val.ListOfTrnDtl)
        for (let i = 0; i < val.ListOfTrnDtl.length; i++) {
          this.dltOrdDltList.push(val.ListOfTrnDtl[i].lk)
        }
        //console.log(this.dltOrdDltList.toString())
        this.dltOrdDltList = this.dltOrdDltList.toString()
        console.log(this.dltOrdDltList)
        this.setFinish()
      }
    },
    setFinish() {
      this.loadingDialog = true
      this.versionError = false
      let mchCode = sessionStorage.getItem('backendMchCode')
      let userName = sessionStorage.getItem('backendLoginedUserName')
      let userInfo = JSON.parse(sessionStorage.getItem('backendLoginInfo'))

      var version = sessionStorage.getItem('version')
      const url = 'Back/SetTrnDtlDate'
      const parameter = {
        av: version,
        kp: mchCode,
        x: userName, //user name
        rd: userInfo.KtnID,
        gm: 3, //Note : 1 = Delete, 3 = End
        ma: this.dltOrdDltList,
        rw: true
      }
      console.log(parameter)
      JS.request(url, parameter)
        .then(response => {
          console.log(response.data)
          if (
            response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
            response.data == 'Version Not Match'
          ) {
            this.versionError = true
          } else {
            this.versionError = false
            if (response.data.ht) {
              this.loadingDialog = false
              this.getOrderList()
            } else {
              this.loadingDialog = false
              this.errorList = response.data
            }
          }
        })
        .catch(error => {
          //console.log(error)
          this.loadingDialog = false
          this.versionError = false
          this.errorList = error
        })
    },
    sureDltAllOrd() {
      this.dltAllOrdDtlDialog = false
      this.loadingDialog = true
      this.versionError = false

      let mchCode = sessionStorage.getItem('backendMchCode')
      //console.log(mchCode)
      let userName = sessionStorage.getItem('backendLoginedUserName')
      let userInfo = JSON.parse(sessionStorage.getItem('backendLoginInfo'))
      console.log(userInfo)
      console.log(userInfo.KtnID)
      var version = sessionStorage.getItem('version')
      const url = 'Back/SetTrnDtlDate'
      const parameter = {
        av: version,
        kp: mchCode,
        x: userName, //user name
        rd: userInfo.KtnID,
        gm: 1, //Note : 1 = Delete, 3 = End
        ma: this.dltOrdDltList,
        rw: true
      }
      console.log(parameter)
      JS.request(url, parameter)
        .then(response => {
          console.log(response.data)
          if (
            response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
            response.data == 'Version Not Match'
          ) {
            this.versionError = true
          } else {
            this.versionError = false
            if (response.data.ht) {
              this.loadingDialog = false
              this.getOrderList()
            } else {
              this.loadingDialog = false
              this.errorList = response.data
            }
          }
        })
        .catch(error => {
          //console.log(error)
          this.loadingDialog = false
          this.versionError = false
          this.errorList = error
        })
    },
    sureDltOrdRow() {
      this.dltOrdDtlDialog = false
      this.loadingDialog = true
      this.versionError = false

      let mchCode = sessionStorage.getItem('backendMchCode')
      //console.log(mchCode)
      let userName = sessionStorage.getItem('backendLoginedUserName')
      let userInfo = JSON.parse(sessionStorage.getItem('backendLoginInfo'))
      console.log(userInfo)
      console.log(userInfo.KtnID)
      var version = sessionStorage.getItem('version')
      const url = 'Back/SetTrnDtlDate'
      const parameter = {
        av: version,
        kp: mchCode,
        x: userName, //user name
        rd: userInfo.KtnID,
        gm: 1, //Note : 1 = Delete, 3 = End
        ma: this.dltOrdDltId,
        rw: true
      }
      console.log(parameter)
      JS.request(url, parameter)
        .then(response => {
          console.log(response.data)
          if (
            response.data == '@#=#@@=$#9@=$#Version Not Match@=$#0' ||
            response.data == 'Version Not Match'
          ) {
            this.versionError = true
          } else {
            this.versionError = false
            if (response.data.ht) {
              this.loadingDialog = false
              this.getOrderList()
            } else {
              this.loadingDialog = false
              this.errorList = response.data
            }
          }
        })
        .catch(error => {
          //console.log(error)
          this.loadingDialog = false
          this.versionError = false
          this.errorList = error
        })
    }
    // toAddOrder() {
    //   sessionStorage.setItem('backEndAddOrd', true)
    //   this.$router.replace('/')
    // }
  }
}
</script>

<style>
.orderDtlSmallTxt {
  margin: 10px;
  text-align: right;
  font-size: 14px !important;
}
.orderDtlMediumTxt {
  padding-left: 5px;
  text-align: left;
  font-size: 14px !important;
  margin: 0;
}
.orderTlAmtTxt {
  margin: 10px;
  text-align: right;
  font-size: 20px !important;
}
.dltRowBtn {
  float: right;
  padding: 10px;
  padding-top: 10px;
}
@media (max-width: 500px) {
  .dltRowBtn {
    float: right;
    padding: 0px;
    padding-top: 10px;
    color: coral;
  }
}
</style>
